import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)   // ✅ register Pinia first
app.use(router)  // ✅ register Router
app.mount('#app') // ✅ mount last
